import type { Meta, StoryFn } from '@storybook/react';

import { Selectable } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Badges/Selectable',
  component: Selectable
} as Meta;

export const SelectableBadge: StoryFn = () => {
  return <Selectable id='selectable'>Selectable</Selectable>;
};
